export const validBankAcctRegex = /^[a-zA-Z0-9\s]*$/;
export const validEnglishOnlyFieldRegex = /^[a-zA-Z0-9_\-\s.]+$/;
export const validSwiftCodeRegex = /^([a-zA-Z]){4}([a-zA-Z]){2}([0-9a-zA-Z]){2}([0-9a-zA-Z]{3})?$/;

export const isvalidEnglishOnlyField = (value: string): boolean =>
    validEnglishOnlyFieldRegex.test(value);

export const isValidBankAccountNo = (value: string): boolean => validBankAcctRegex.test(value);

export const isValidSwiftCode = (value: string): boolean => validSwiftCodeRegex.test(value);

export const isValidRoutingNumber = (value: string): boolean => {
    // all valid routing numbers are 9 numbers in length
    if (value.length !== 9) {
        return false;
    }

    // routing numbers starting with 5 are internal routing numbers
    // usually found on bank deposit slips
    if (value[0] === '5') {
        return false;
    }

    // http://en.wikipedia.org/wiki/Routing_transit_number#MICR_Routing_number_format
    const checksumTotal =
        7 *
            (parseInt(value.charAt(0), 10) +
                parseInt(value.charAt(3), 10) +
                parseInt(value.charAt(6), 10)) +
        3 *
            (parseInt(value.charAt(1), 10) +
                parseInt(value.charAt(4), 10) +
                parseInt(value.charAt(7), 10)) +
        9 *
            (parseInt(value.charAt(2), 10) +
                parseInt(value.charAt(5), 10) +
                parseInt(value.charAt(8), 10));
    const checksumMod = checksumTotal % 10;
    return checksumMod === 0;
};

export const isValidForeignRoutingNumber = (value?: string): boolean => {
    if (!value) {
        return true;
    }
    return value.length === 9;
};
